module.exports = __webpack_public_path__ + "img/cattunnel12.2e696cd5.jpg";